function isBoolean(key) {
  return /^true|false|0|1$/.test(key);
}

function isInteger(key) {
  return /^-?(?:0|[1-9][0-9]*)$/.test(key);
}

const Key = {isBoolean, isInteger};

module.exports = {Key};
